import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';

import IdentityAvatarContainer from '../../../../../../../containers/global/identity/IdentityAvatarContainer';
import { AVATAR_SIZE_36 } from '../../../../../../../constants/avatar-sizes';
import { getIdentityName } from '../../../../../../../util/identity';
import WaldoSpeechBubble from '../../../../../../../components/global/WaldoSpeechBubble';
import {
  albumFolderRequiresTagsToOnboard,
  getEligibleTagsByIdentityGender,
  isUniformAlbumFolderTagConfigurable,
} from '../../helpers';
import { AlbumFolderTags } from '../../../../../../../graphql/queries/album-folder-tags';
import { getTagsByType } from '../../../../../../../util/album-folder-tags';
import { ALBUM_FOLDER_TAG_TYPE } from '../../../../../../../constants/album-folder-tags';

const propTypes = {
  className: PropTypes.string,
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  tags: PropTypes.shape({
    total: PropTypes.number,
    records: PropTypes.shape({
      uniform_numbered: PropTypes.number,
    }),
  }),
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    tag_join_enabled: PropTypes.bool,
  }),
  onRequestClose: PropTypes.func,
};

const IdentityTagSelectionHeader = ({
  tags,
  identity,
  className,
  albumFolder,
  onRequestClose,
}) => {
  const classes = classNames({
    'identity-tag-selection-heading': true,
    [className]: !!className,
  });
  const identityName = getIdentityName(identity);
  const eligibleTags = getEligibleTagsByIdentityGender(
    tags,
    identity?.gender,
    !albumFolderRequiresTagsToOnboard(albumFolder),
  );
  const isSingleTagOnboarding = eligibleTags?.length === 1;

  return (
    <div className={classes}>
      {onRequestClose && (
        <div className="d-flex justify-content-end mb-2">
          <button
            aria-label="Dismiss Modal"
            onClick={() => onRequestClose()}
            className="btn-dismiss btn-modal-dismiss"
          />
        </div>
      )}
      <h3 className="text-center mb-2">
        Help Waldo find photos for <br />
        <p className="mt-2">
          <IdentityAvatarContainer size={AVATAR_SIZE_36} identity={identity} />{' '}
          {identityName}
        </p>
      </h3>
      {!isSingleTagOnboarding && (
        <WaldoSpeechBubble position="right" className="mb-4">
          I can find photos based on team &amp; jersey number!
        </WaldoSpeechBubble>
      )}
    </div>
  );
};

IdentityTagSelectionHeader.propTypes = propTypes;

const withAlbumFolderTags = graphql(AlbumFolderTags, {
  options: ({ match, albumFolder }) => ({
    variables: {
      id: albumFolder?.id ?? match?.params?.albumFolderId,
    },
  }),
  props: ({ data: { albumFolder, loading: loadingTags } = {} }) => ({
    tags: getTagsByType(
      ALBUM_FOLDER_TAG_TYPE.UNIFORM,
      albumFolder?.tags?.records,
    ).filter(isUniformAlbumFolderTagConfigurable),
    loadingTags,
  }),
});

export default compose(withAlbumFolderTags)(IdentityTagSelectionHeader);
